import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Company Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-accent rounded-2xl flex items-center justify-center shadow-lg">
          <Icon name="Zap" size={32} className="text-accent-foreground" />
        </div>
      </div>

      {/* Application Title */}
      <h1 className="text-3xl font-bold text-text-primary mb-2">
        NFC Card Admin
      </h1>
      <p className="text-text-secondary text-lg mb-6">
        Digital Card Management System
      </p>

      {/* Welcome Message */}
      <div className="bg-surface border border-border rounded-lg p-4 mb-6">
        <h2 className="text-xl font-semibold text-text-primary mb-2">
          Welcome Back
        </h2>
        <p className="text-text-muted text-sm">
          Sign in to access your NFC card management dashboard and billing operations.
        </p>
      </div>

      {/* Security Badge */}
      <div className="flex items-center justify-center space-x-2 text-sm text-text-muted">
        <Icon name="Shield" size={16} className="text-success" />
        <span>Secure Admin Access</span>
        <div className="w-1 h-1 bg-text-muted rounded-full"></div>
        <span>Enterprise Grade Security</span>
      </div>
    </div>
  );
};

export default LoginHeader;